/* eslint-disable @typescript-eslint/triple-slash-reference */
/* eslint-disable no-undef */
export class ServiceConfiguration {
  static getReportUrl(): string {
    if (process.env.REACT_APP_SERVICE_ENV) {
      return process.env.REACT_APP_SERVICE_ENV;
    }
    return '/api/dynamicreports';
  }
}
